export default __webpack_public_path__ + "images/79fec0cbb16e59c9f617bced466450ea.svg";